module.exports = __webpack_public_path__ + "static/media/profile-tickets.e1d9fc4e.png";